import { IntentTypeEnum as t } from "../../enum/intent-type-enum.mjs";
const m = (r, n) => n === t.setup ? r.confirmCardSetup : r.confirmCardPayment;
export {
  m as getStripeCardConfirmHandler
};
